import * as React from "react";
const DividerSizeMediumSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 7h-1V5h-2V4h2a1 1 0 0 1 1 1v2Zm-9 8H4a1 1 0 0 1-1-1v-2h1v2h2v1ZM3 7h1V5h2V4H4a1 1 0 0 0-1 1v2Zm12 7a1 1 0 0 1-1 1h-2v-1h2v-2h1v2ZM3 9h12v1H3V9Z" }));
DividerSizeMediumSmall.displayName = "DividerSizeMediumSmall";
var DividerSizeMediumSmall_default = DividerSizeMediumSmall;
export {
  DividerSizeMediumSmall_default as default
};
